﻿window.cBuilderEmailWidgetSeparateur = function(option) {
    var Me = this

    this.mGetButton = function () {
        var $DivBt = $("<div class='widget state-hover' typewidget='dxwidgetseparateur'/>").css({
            "padding": "5px",
            "width": "80px",
            "height": "95px",
            "cursor": "move",
            "margin": "5px",
            border: "3px solid " + theme.backgroundColorTitle,
            "text-align": "center",
            "display": "inline-block"
        })
        var $I = $("<i class='" + Me.icone + " dx-theme-accent-as-text-color' style='font-size:260%;height:50px;'></i>").appendTo($DivBt)
        var $Div = $("<div style='font-family:barlow condensed;font-size:100%;height:calc(100% - 60px);display:flex;align-items:center;justify-content:center;line-height:1;'>Séparateur</div>").appendTo($DivBt)
        $DivBt.attr("title", "Ajouter une ligne séparatrice entre deux widgets")
        return $DivBt
    }

    this.mCreateElement = function () {
        option.element = $("<tr class='widget dxwidgetseparateur'>")
        $("<!-- DEBUT SEPARATEUR -->").appendTo(option.element)
        var $Td = $("<td style='width:100%;' width='100%' class='tdwidget bodywidget widgetheightauto' separateurwidthpercent='30'>").appendTo(option.element)
        var jsonDuplik = JSON.parse(JSON.stringify(option.dxBuilderEmailPage.mJsonCssGuideProperty("separateur")))
        for (var prop in jsonDuplik) jsonDuplik[prop] = ""
        $Td.attr("jsoncssdatawidget", JSON.stringify(jsonDuplik))

        var $TablePaddingBorder = $("<table  border='0' cellspacing='0' cellpadding='0' style='width:100%'/>").appendTo($Td)
        var $Tr = $("<tr/>").appendTo($TablePaddingBorder)
        var $Td = $("<td class='contenuwidget tdpaddingborderwidget'/>").appendTo($Tr)

        var $Table = $("<table border='0' cellspacing='0' cellpadding='0' style='width:100%' class='tablewidget'>").appendTo($Td)

        var $TrTableBt = $("<tr/>").appendTo($Table)
        var $Td = $("<td style='width:35%' class='tdleft'></td>").appendTo($TrTableBt)
        var $Td = $("<td style='width:30%' class='tdcenter'></td>").appendTo($TrTableBt)
        var $Td = $("<td style='width:35%' class='tdright'></td>").appendTo($TrTableBt)
        $("<!-- FIN SEPARATEUR -->").appendTo(option.element)
    }

    function mGetTdLeft() { return $(option.element.find(".tdleft")[0]) }
    function mGetTdCenter() { return $(option.element.find(".tdcenter")[0]) }
    function mGetTdRight() { return $(option.element.find(".tdright")[0]) }

    this.nom = "Séparateur"
    this.icone = "fas fa-minus"

    this.mAddCtrlStyle = function (contentElement) {
        contentElement.empty()
        //$("<br/>").appendTo(contentElement)

        var jsonCssDataOriginalValue = JSON.parse(option.parent.mGetBodyWidget().attr("jsoncssdatawidget"))
        var jsonCssData = {}
        for (var prop in option.dxBuilderEmailPage.mJsonCssGuideProperty("separateur")) {
            jsonCssData[prop] = ""
            if (typeof jsonCssDataOriginalValue[prop] != 'undefined') jsonCssData[prop] = jsonCssDataOriginalValue[prop]
        }

        $("<div style='width:1px;white-space:nowrap;font-size:120%;font-weight:bold;' class=''>Largeur séparateur:</div>").appendTo(contentElement)
        $("<div/>").appendTo(contentElement).dxCtrlBuilderEmailStyleLargeur({
            allowDefaut: true,
            value: jsonCssData.width.toString().replace("%", ""),
            onValueChanged: function (value) {
                jsonCssDataOriginalValue.width = value + "%"
                option.parent.mGetBodyWidget().attr("jsoncssdatawidget", JSON.stringify(jsonCssDataOriginalValue))
                option.onValueChanged()
            }
        })

        $("<div style='width:1px;white-space:nowrap;font-size:120%;font-weight:bold;margin-top:10px;' class=''>Ligne séparateur:</div>").appendTo(contentElement)
        $("<div/>").appendTo(contentElement).dxCtrlBuilderEmailStyleBordure({
            dxBuilderEmailPage: option.dxBuilderEmailPage,
            allowDefaut: true,
            borderWidth: jsonCssData["border-top-width"],
            borderStyle: jsonCssData["border-top-style"],
            borderColor: jsonCssData["border-top-color"],
            onValueChanged: function (e) {
                e.values.forEach(function (value) {
                    if (value.value.length > 0) {
                        if (value.prop == "border-width") { jsonCssDataOriginalValue["border-top-width"] = value.value }
                        else if (value.prop == "border-style") { jsonCssDataOriginalValue["border-top-style"] = value.value }
                        else if (value.prop == "border-color") { jsonCssDataOriginalValue["border-top-color"] = value.value }
                    } else {
                        if (value.prop == "border-width") { delete jsonCssDataOriginalValue["border-top-width"] }
                        else if (value.prop == "border-style") { delete jsonCssDataOriginalValue["border-top-style"] }
                        else if (value.prop == "border-color") { delete jsonCssDataOriginalValue["border-top-color"] }
                    }
                })
                option.parent.mGetBodyWidget().attr("jsoncssdatawidget", JSON.stringify(jsonCssDataOriginalValue))
                option.onValueChanged()
            }
        })
    }

    this.mRemoveStyle = function () {
        var jsonCssData = JSON.parse(option.parent.mGetBodyWidget().attr("jsoncssdatawidget"))
        for (var prop in option.dxBuilderEmailPage.mJsonCssGuideProperty("separateur")) {
            delete jsonCssData[prop]
        }
        option.parent.mGetBodyWidget().attr("jsoncssdatawidget", JSON.stringify(jsonCssData))
        option.onValueChanged()
    }

    this.mUpdateCss = function () {
        var jsonCssData = JSON.parse(option.parent.mGetBodyWidget().attr("jsoncssdatawidget"))
        for (var prop in option.dxBuilderEmailPage.mJsonCssGuideProperty("separateur")) {
            if (prop == "width") {
                var widthPercent = 0
                if (typeof jsonCssData[prop] != 'undefined' && jsonCssData[prop].length > 0) {
                    widthPercent = jsonCssData[prop].replace("%", "")
                } else {
                    widthPercent = option.dxBuilderEmailPage.mJsonCssGuideProperty("separateur", prop).replace("%", "")
                }
                var rest = 100 - widthPercent
                mGetTdCenter().attr("width", widthPercent + "%")
                mGetTdCenter().css("width", widthPercent + "%")
                switch (option.parent.mGetTextAlignCss()) {
                    case "left":
                        mGetTdLeft().attr("width", "0")
                        mGetTdLeft().css("width", "0px")
                        mGetTdRight().attr("width", rest + "%")
                        mGetTdRight().css("width", rest + "%")
                        break;
                    case "center":
                        var restDiv2 = rest / 2
                        mGetTdLeft().attr("width", restDiv2 + "%")
                        mGetTdLeft().css("width", restDiv2 + "%")
                        mGetTdRight().attr("width", restDiv2 + "%")
                        mGetTdRight().css("width", restDiv2 + "%")
                        break;
                    case "right":
                        mGetTdLeft().attr("width", rest + "%")
                        mGetTdLeft().css("width", rest + "%")
                        mGetTdRight().attr("width", "0")
                        mGetTdRight().css("width", "0px")
                        break;
                }
            } else {
                if (typeof jsonCssData[prop] != 'undefined' && jsonCssData[prop].length > 0) {
                    mGetTdCenter().css(prop, jsonCssData[prop])
                } else {
                    mGetTdCenter().css(prop, option.dxBuilderEmailPage.mJsonCssGuideProperty("separateur", prop))
                }
            }
        }
    }

}